var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "empty" } },
    [
      _c("img", { attrs: { src: require("@/assets/empty.png"), alt: "" } }),
      _c("p", [_vm._v("You don’t have any record now")]),
      _c("common-btn", { staticClass: "btn", attrs: { click: _vm.to } }, [
        _vm._v("Apply Now"),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }